import { GET_DATA_FILTERREPORT_PLANTYPE } from "../actions/actionTypes";
import {
  GetFilterReportHandleSuccessAction,
  RequestFilterReportHandleFaileAction,
} from "../actions";

import { put, takeLatest } from "redux-saga/effects";
import { Api } from "./api";

function* GetFilterReport(action) {
  try {
    const DataFilterReport = yield Api.GetFilterReportFromApi(action.id);
    yield put(GetFilterReportHandleSuccessAction(DataFilterReport));
  } catch (error) {
    yield put(RequestFilterReportHandleFaileAction(error));
  }
}
export function* watchGetFilterReport() {
  yield takeLatest(GET_DATA_FILTERREPORT_PLANTYPE, GetFilterReport);
}
